<template>
    <div>
        <b-form-checkbox
            v-if="toggleActive"
            id="checkbox-template"
            name="checkbox-template"
            v-model="isTemplate"
        >
            Include Order Template?
        </b-form-checkbox>
        <b-card class="mb-4" title="Template" title-tag="h6" v-if="isTemplate">
            <b-form-group
                v-if="includeOrderType"
                id="input-group-type"
                label="Type:"
                label-for="input-type"
                label-class="font-weight-bold pt-0"
                label-cols="3"
            >
                <b-form-select
                    id="input-type"
                    v-model="order_type_id"
                    :options="orderTypes | mapOptions"
                    :disabled="disabled"
                    required
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled
                            >Select Order Type</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group
                id="input-group-category"
                label="Category:"
                label-class="font-weight-bold pt-0"
                label-cols="3"
                label-for="input-category"
            >
                <b-form-select
                    id="input-category"
                    v-model="category_id"
                    :options="categories | mapOptions"
                    :disabled="disabled"
                    required
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled
                            >Select Template Category</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group
                id="input-group-template"
                label="Name:"
                label-class="font-weight-bold pt-0"
                label-cols="3"
                label-for="input-template"
            >
                <b-form-select
                    id="input-template"
                    v-model="order_template_id"
                    :options="filteredTemplates | mapOptions"
                    :disabled="disabled"
                    required
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled
                            >Select Template</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-form-group>
        </b-card>
    </div>
</template>


<script>
export default {
    data() {
        return {
            category_id: null,
            order_template_id: null,
            order_type_id: null,
            isTemplate: true,
        }
    },
    props: {
        toggleActive: {
            default: false,
            type: Boolean,
        },

        value: {
            default: null,
            type: Number,
        },

        orderTypeId: {
            default: null,
            type: Number,
        },

        includeOrderType: {
            default: false,
            type: Boolean,
        },

        disabled: {
            default: false,
            type: Boolean,
        },
    },
    filters: {
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },
    created() {
        this.$store.dispatch('orderCategory/fetchAll')
        this.$store.dispatch('orderTemplate/fetchAll')
    },
    mounted() {
        this.order_type_id = this.orderTypeId
        this.setTemplate(this.value)
    },
    watch: {
        value: function (val) {
            this.setTemplate(val)
        },
        order_template_id: function (val) {
            this.$emit('input', val)
        },
        orderTypeId: function (val) {
            this.order_type_id = val
        },
        isTemplate: function (val) {
            if (!val) this.order_template_id = null
        },
    },
    computed: {
        filteredTemplates() {
            return this.templates.filter(
                x =>
                    x.order_type_id === this.order_type_id &&
                    x.order_category_id === this.category_id
            )
        },
        categories() {
            return this.$store.state.orderCategory.categories
        },
        templates() {
            return this.$store.state.orderTemplate.templates
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
    },

    methods: {
        setTemplate(id) {
            const x = this.templates.find(x => x.id === id)
            if (x) {
                this.order_type_id = x.order_type_id
                this.category_id = x.order_category_id
                this.order_template_id = id
            }
        },
    },
}
</script>